var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1812 15.7259L9.92 3.33117C9.5784 3.122 9.18716 3.0078 8.78667 3.00039C8.38619 2.99297 7.99098 3.0926 7.64188 3.28898C7.29609 3.48232 7.00804 3.76427 6.80736 4.10583C6.60667 4.4474 6.50058 4.83626 6.5 5.23242V30.019C6.50261 30.6132 6.74108 31.1821 7.163 31.6006C7.58491 32.0191 8.15574 32.2529 8.75 32.2507C9.16478 32.2505 9.5715 32.1362 9.92563 31.9202L30.1812 19.5255C30.5068 19.3271 30.7759 19.0482 30.9626 18.7158C31.1493 18.3833 31.2474 18.0084 31.2474 17.6271C31.2474 17.2458 31.1493 16.8709 30.9626 16.5384C30.7759 16.206 30.5068 15.9271 30.1812 15.7287V15.7259ZM8.75 29.9923V5.2507L28.9761 17.6257L8.75 29.9923Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.fdf0e095acf5b6599ce413ab0559328b.svg";
export { ForwardRef as ReactComponent };